import React, { useState } from 'react'
import styles from "./Styles/Tasks.module.css"
import Button from "../../Components/Button"
import { BsClipboardPlus } from 'react-icons/bs'
import { HiOutlineUsers } from 'react-icons/hi'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { FiEdit } from 'react-icons/fi'

export default function Tasks() {

  const [tasks, setTasks] = useState(['Meeting','Phone Call','Follow Up','Phone Call'])
  
  return (
    <div className={styles.container}>
        <header>
        <p>Tasks</p>
        <Button bgColor="#299EFE" width={157} title="Add Task" />
      </header>

      <div className={styles.card}>
            {tasks.map(i => {
                return <div className={styles.task}>
                <main>
                    <p className={styles.taskHeading}>
                      <HiOutlineUsers size={14} color="#a9d7fc" />
                      {i}
                    </p>
                    <div className={styles.taskDetails}>
                        <div>
                            <div>
                                <h2>Subject</h2>
                                <h3>Layout Planning</h3>
                            </div>
                            <div>
                                <h2>Location</h2>
                                <h3>Gurugram, Haryana</h3>
                            </div>
                        </div>
                        <div>
                            <div>
                                <h2>
                                Schedule
                                </h2>
                                <h3>
                                Nov 23, 2022 | 14:30 PM - 15:30 PM
                                </h3>
                            </div>
                        </div>
                    </div>
                </main>
                <aside>
                        <div className={styles.editDelete}>
                            <FiEdit color="#299EFE" size={22} />
                            <RiDeleteBin6Line color="#F7685B" size={22} />
                        </div>
                        <p className={styles.status}>
                           Upcoming
                        </p>
                </aside>
            </div>
            })}    
        </div>  
    </div>
  )
}
